module.exports = __webpack_public_path__ + "static/media/Up.5020d5ec.svg";